import * as actionTypes from "../actions/actionTypes";

export default function uploadQueue(state = [], action) {
  switch (action.type) {
    case actionTypes.ENQUEUE_UPLOAD:
      return state.concat([action.actionToEnqueue]);
    case actionTypes.DEQUEUE_UPLOAD:
      return state.slice(1);
    default:
      return state;
  }
}
